import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { PasswordForm } from '../components/PasswordForm'
import { useChangePassword } from '../hooks'
import type { ChangePasswordInput } from '../types'

export function ChangePassword() {
  const { t } = useTranslation('feature')
  const { mutateAsync: change } = useChangePassword()

  const onSubmit = async (values: ChangePasswordInput) => {
    try {
      await change(values)
      toast.success(t('password.changed'))
    } catch {
      toast.error(t('password.changeFailed'))
    }
  }

  return <PasswordForm onSubmit={onSubmit} />
}
